import * as spinnerComponent from './spinner';

// フォームを送信
export function submitAction () {
  let form = document.getElementById('c-main').querySelector('form');
  if (!!form) {
    form.addEventListener('submit', function (event) {
      if (form.dataset['remote'] == 'true') {
        // スピナーを表示
        spinnerComponent.spinnerShow();
      }
    })
  }
}

// ajaxをレスポンスを受け取って行う処理
export function ajaxSearchGroupResult () {
  document.addEventListener('ajax:success', function (event) {
    let form = document.getElementById('c-main').querySelector('form');
    if (event.target === form || event.target.classList.contains('page-link') ) {
      let newHtml = '';
      if (event.target === form) {
        newHtml = event.detail[0];
      } else {
        newHtml = event.detail[0].querySelector('#c-main #search-result');
        if (!!newHtml) {
          newHtml = newHtml.outerHTML;
        }
      }

      if (!!newHtml) {
        let searchResultElement = document.querySelector('div#search-result');
        if (!!searchResultElement) {
          searchResultElement.innerHTML = newHtml;
        } else {
          let rowBox = document.createElement('div');
          rowBox.classList.add('row');
          let colBox = document.createElement('div');
          colBox.classList.add('col-12');
          rowBox.appendChild(colBox);
          var box = document.createElement('div');
          box.id = 'search-result';
          box.innerHTML = newHtml;
          colBox.appendChild(box);
          form.after(rowBox);
        }
        // スクロール
        searchResultElement = document.querySelector('div#search-result');
        let rect = searchResultElement.getBoundingClientRect();
        window.scrollTo(0, window.pageYOffset + rect.top);
        stopPagenationSubmitAction();
      }
    }
    // スピナーを削除
    spinnerComponent.spinnerHide();
  }, false);
}

// ページネートのリンクを無効化してフォームを送信
export function stopPagenationSubmitAction () {
  let searchResultElement = document.querySelector('div#search-result');
  if (!!searchResultElement) {
    let linkElements = document.querySelectorAll('ul.pagination a');
    if (!!linkElements.length) {
      for (let i = 0; i < linkElements.length; i++) {
        if (!!linkElements[i]) {
          linkElements[i].addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();

            let form = document.getElementById('c-main').querySelector('form');
            if (!!form) {
              let hiddenPageElement = form.querySelector('#page-number');
              if (!!hiddenPageElement) {
                // リンクのhrefからページ番号を取得
                let url = new URL(this.href);
                let params = url.searchParams;
                let pageNumber = params.get('page');
                if (!!pageNumber) {
                  hiddenPageElement.value = pageNumber;
                } else {
                  hiddenPageElement.value = '1';
                }
                let submitButton = form.querySelector('button.search[type="submit"]');
                submitButton.click();
                hiddenPageElement.value = '';
              }
            }
          });
        }
      }
    }
  }
}
